import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const colorMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50",
  accent: "bg-accent-100 text-accent-900 group-hover:bg-accent-500 group-hover:text-primary-950",
  secondary: "bg-secondary-100 text-secondary-900 group-hover:bg-secondary-500 group-hover:text-background-50",
};

export default function CategoryStrip() {
  return (
    <section aria-labelledby="category-title" className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
      <div className="mb-7 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            内容栏目
          </p>
          <h2 id="category-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            五个入口，读懂一场风波
          </h2>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">
          从一分钟快讯到六周调查，我们按信息深度分层呈现，你可以按需要选择读法。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {categories.map((item) => (
          <Link
            key={item.slug}
            to={`/category/${item.slug}`}
            className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
          >
            <span
              className={`flex h-11 w-11 items-center justify-center rounded-md transition-colors ${
                colorMap[item.color] ?? colorMap.secondary
              }`}
            >
              <i className={`${item.icon} text-xl`} aria-hidden="true" />
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.name}</h3>
            <p className="mt-1 text-xs font-medium tracking-wide text-accent-700">{item.tagline}</p>
            <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 line-clamp-3">
              {item.desc}
            </p>
            <span className="mt-4 flex items-center justify-between text-xs text-secondary-600">
              <span>{item.total} 篇在库</span>
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}